import React from 'react';
import '../index.css';

function AppTitle() {
  return (<h2 className="app-title">Kāraj To-Do</h2>);
};

export default AppTitle;